/* iBorad
 ----------------------------------------------------------------*/
module.exports = iBorad

function iBorad(element, options) {
  this.defaultOptions = {
    type: 'left',
    speed: 1500,
    cycle: 3600
  }
  this.options = options || {}
  this.options = $.extend({}, this.defaultOptions, this.options);

  this.$element = $(element)
}
iBorad.prototype = {
  constructor: iBorad,
  init: function () {
    var self = this,
      boxTotalWidth = 0

    self.$active = this.$element.find('.board-slide .box-active')
    if (self.options.type == 'left') {
      self.$element.find('.board-slide .box').each(function () {
        boxTotalWidth += $(this).outerWidth()
      })
      // self.$element.find('.board-slide').css({width: boxTotalWidth})
    }
    self.next()
    self.isCycle || self.cycle()
  },
  next: function () {
    var self = this,
      $target = self.$active.next()
      // , curBoxWidth = self.$active.outerWidth()
      ,
      $copyBox = self.$active.clone().removeClass('box-active'),
      slideOpt, slideValue

    switch (self.options.type) {
      case 'left':
        slideValue = '-' + self.$active.outerWidth() + 'px'
        slideOpt = {
          marginLeft: slideValue
        }
        break
      case 'top':
        slideValue = '-' + self.$active.height() + 'px'
        slideOpt = {
          marginTop: slideValue
        }
        break
      default:
        break
    }
    self.$active.animate(slideOpt, self.options.speed, 'linear', function () {
      $copyBox.appendTo(self.$element.find('.board-slide'))
      $(this).remove()
    })
    $target.addClass('box-active')
    self.$active = $target
  },
  cycle: function () {
    var self = this
    if (!self.isCycle) {
      self.isCycle = setInterval(function () {
        self.next()
      }, self.options.cycle)
    }
  }
};



// WEBPACK FOOTER //
// ./common/iBorad.js